import {TableCell, TableRow, Typography} from "@mui/material";
import {useNavigate} from "react-router-dom";
import moment from "moment/moment";

const CompanyElement = ({item}) => {

  let navigate = useNavigate()

  return (
      <TableRow
          onClick={() => navigate(`/app/companies/${item.id}`)}
          sx={{"&.MuiTableRow-root" : {
              border: "1px solid #E7E9EE",
              backgroundColor: "#F9FAFB",
              cursor: "pointer",
              "&:hover" : {
                backgroundColor: "#dec7f6"
              },
              boxShadow: "0px 0px 1px rgba(12, 26, 75, 0.1), 0px 4px 8px rgba(20, 37, 63, 0.04)"
            },
            "& .MuiTableCell-root": {
              padding: "12px",
              fontSize: "0.85rem"
            }
          }}>
        <TableCell align={"left"}>
          <Typography fontWeight={600} fontSize="0.9rem">
            {item.name}
          </Typography>
        </TableCell>
        <TableCell align={"left"}>
          {item.industry}
        </TableCell>
        <TableCell align={"left"}>
          <Typography
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              fontSize: "0.85rem"
            }}
          >
            {item.info}
          </Typography>
        </TableCell>
        <TableCell align="center">
          {moment(item.createDate).format("DD/MM/YY")}
        </TableCell>
      </TableRow>
  )
};

export default CompanyElement;
